import { IPagination } from 'app/types/common';

export interface IOrganisationAddressesState {
  readonly organisationAddressesById?: any;
  readonly organisationAddressIds?: string[];
  readonly hasLoaded?: boolean;
  readonly hasLoaded?: boolean;
  readonly hasSaved?: boolean;
  readonly hasFailed?: boolean;
  readonly isLoading?: boolean;
  readonly isSaving?: boolean;
  readonly selectOrganisationAddressLoading?: boolean;
  readonly hasLoaded?: boolean;
  readonly showAddOrganisationAddress?: boolean;
  readonly requestedData?: any;
  readonly backendErrors?: any;
  readonly organisationOrganisationAddressIds?: string[];
  readonly currentOrganisationAddressId?: string;
  readonly filterConfig?: any;
  readonly sortConfig?: any;
  readonly pagination?: IPagination;
}

export interface IOrganisationAddressesSelector
  extends IOrganisationAddressesState {
  readonly currentOrganisationAddress?: any;
  readonly currentFormOrganisationAddress?: any;
  readonly organisationAddressesFilteredByOrganisationInSelectFormat?: any;
  readonly organisationAddressesByTagAndIdInSelectFormat?: any;
  readonly organisationAddressesByIdInSelectFormat?: any;
  readonly organisationAddressesFilteredByCompetitionInSelectFormat?: any;
  readonly organisationAddressesFilteredByIdInSelectFormat?: any;
}

export enum OrganisationAddressesActionTypes {
  GET_ALL_ORGANISATION_ADDRESSES_REQUESTED = 'redux-app/organisation-addresses/GET_ALL_ORGANISATION_ADDRESSES_REQUESTED',
  GET_ALL_ORGANISATION_ADDRESSES_PENDING = 'redux-app/organisation-addresses/GET_ALL_ORGANISATION_ADDRESSES_PENDING',
  GET_ALL_ORGANISATION_ADDRESSES_SUCCESS = 'redux-app/organisation-addresses/GET_ALL_ORGANISATION_ADDRESSES_SUCCESS',
  GET_ALL_ORGANISATION_ADDRESSES_FAIL = 'redux-app/organisation-addresses/GET_ALL_ORGANISATION_ADDRESSES_FAIL',
  GET_ORGANISATION_ADDRESS_REQUESTED = 'redux-app/organisation-addresses/GET_ORGANISATION_ADDRESS_REQUESTED',
  GET_ORGANISATION_ADDRESS_PENDING = 'redux-app/organisation-addresses/GET_ORGANISATION_ADDRESS_PENDING',
  GET_ORGANISATION_ADDRESS_SUCCESS = 'redux-app/organisation-addresses/GET_ORGANISATION_ADDRESS_SUCCESS',
  GET_ORGANISATION_ADDRESS_FAIL = 'redux-app/organisation-addresses/GET_ORGANISATION_ADDRESS_FAIL',
  UPDATE_ORGANISATION_ADDRESS_REQUESTED = 'redux-app/organisation-addresses/UPDATE_ORGANISATION_ADDRESS_REQUESTED',
  UPDATE_ORGANISATION_ADDRESS_PENDING = 'redux-app/organisation-addresses/UPDATE_ORGANISATION_ADDRESS_PENDING',
  UPDATE_ORGANISATION_ADDRESS_SUCCESS = 'redux-app/organisation-addresses/UPDATE_ORGANISATION_ADDRESS_SUCCESS',
  UPDATE_ORGANISATION_ADDRESS_FAIL = 'redux-app/organisation-addresses/UPDATE_ORGANISATION_ADDRESS_FAIL',
  CREATE_ORGANISATION_ADDRESS_REQUESTED = 'redux-app/organisation-addresses/CREATE_ORGANISATION_ADDRESS_REQUESTED',
  CREATE_ORGANISATION_ADDRESS_PENDING = 'redux-app/organisation-addresses/CREATE_ORGANISATION_ADDRESS_PENDING',
  CREATE_ORGANISATION_ADDRESS_SUCCESS = 'redux-app/organisation-addresses/CREATE_ORGANISATION_ADDRESS_SUCCESS',
  CREATE_ORGANISATION_ADDRESS_FAIL = 'redux-app/organisation-addresses/CREATE_ORGANISATION_ADDRESS_FAIL',
  DELETE_ORGANISATION_ADDRESS_REQUESTED = 'redux-app/organisation-addresses/DELETE_ORGANISATION_ADDRESS_REQUESTED',
  DELETE_ORGANISATION_ADDRESS_PENDING = 'redux-app/organisation-addresses/DELETE_ORGANISATION_ADDRESS_PENDING',
  DELETE_ORGANISATION_ADDRESS_SUCCESS = 'redux-app/organisation-addresses/DELETE_ORGANISATION_ADDRESS_SUCCESS',
  DELETE_ORGANISATION_ADDRESS_FAIL = 'redux-app/organisation-addresses/DELETE_ORGANISATION_ADDRESS_FAIL',
  SELECT_ORGANISATION_ADDRESS_REQUESTED = 'redux-app/organisation-addresses/SELECT_ORGANISATION_ADDRESS_REQUESTED',
}

export default null;
